<app-asset-icon [asset]="asset()"></app-asset-icon>
@if (navigation()) {
  <a [routerLink]="navigation()" title="{{ label() }}" (click)="onLinkClicked($event)">{{
    label()
  }}</a>
} @else {
  <span title="{{ label() }}">{{ label() }}</span>
}
